<template>
  <header class="portal-brand">
      <img class="ima-logo ml-2" src="@/assets/image/authentication/ima-logo-white.svg" width="70"
           alt="Logo IMA Alagoas">
  </header>
</template>

<script>
export default {
  name: 'PortalBrand',
};
</script>

<style scoped lang="scss">
.portal-brand {
  & {
    display: flex;
    align-self: flex-start;
    justify-items: center;
    align-items: center;
    background: #388e3c;
    border-radius: 0 35px 35px 0;
    padding: .5rem 2rem;
    width: 170px;
    height: 64px;
  }

  > .title {
    margin-bottom: 0;
    font-weight: 200;
    text-transform: uppercase;
    line-height: 1;
    color: #fff;
  }
}
</style>
